import { createContext, useState, useEffect } from "react";
import axios from "axios";
import Cookies from "universal-cookie";

const cookies = new Cookies();

export const AuthContext = createContext();

export const AuthProvider = ({children}) => {

    const [user, setUser] = useState(JSON.parse(localStorage.getItem('usprovdb')) || null);
    const [token, setToken] = useState(cookies.get('pvckid') || '');
    const [errmsg, setErrmsg] = useState('');
    const [config, setconfig] = useState({});
    
    const getData = async (datacnf) => {
        var BaseUrl = datacnf.baseUrl || 'http://localhost/wservices/';
        var AppId = datacnf.appId || '';
        var tkid = cookies.get('pvckid');
        
        try{
            const data = {
                apikey: AppId || '',
                action: 'login',
                provider: 'proveedor',
                data: {
                    tkid: tkid || '',
                    user: '',
                    password: ''
                }
            }
            
            //Limpiamos el error
            setErrmsg('');
            
            await axios.post(BaseUrl, data)
            .then(response => {
                return response.data
            })
            .then(datos => {
                //console.log('Login automatico'); 
                
                if((datos.type || '') === ''){
                    setErrmsg('No hubo respuesta del servidor');
                    return;
                }
                
                //Ya tenemos una respuesta valida, ahora la procesamos
                if(datos.type === 'error'){
                    setErrmsg('No hay conexion 1, ' + datos.code + ' - ' + datos.message);
                    return;
                }
                
                const resultado = datos.data || {};
                setUser({
                    usuario: resultado.usuario || '',
                    descripcion: resultado.descripcion || '',
                    tabla: resultado.tabla || '',
                    clave: resultado.clave || '',
                    login: true
                });
                
                cookies.set('pvckid',resultado.tkid, { path: '/' });
                //console.log('Login correcto');
            }).catch(error => {
                console.log(error);
                setErrmsg('Error desconocido');
            });
        }catch(error){
            console.log(error);
            setErrmsg('Error al consultar datos');
        }
    }

    const getConfig = async() => {
        
        await axios.get('./assets/config/config.json', {headers:{
            'Content-Type':'application/json',
            'Accept': 'application/json'
        }})
        .then(response => {
            const conf = response.data;
            setconfig(conf);
            getData(conf);
            localStorage.setItem('config',JSON.stringify(conf));
        }).catch(error => {
            const errd = { baseUrl: 'http://localhost/wservices/', appId: '' };
            setconfig(errd);
            getData(errd);
        });
    }

    useEffect(() => { 
        try{
            getConfig();
        }catch(error){
            localStorage.remove('usprovdb');
        }
    }, []);

    const sesion = {
        user,
        errmsg,
        token,
        config,
        errclear(){
            setErrmsg('');
        },
        login(){ 
            var userval = JSON.parse(localStorage.getItem("usprovdb")) || null;
            var usertk = cookies.get('pvckid') || '';
            setUser(userval);
            setToken(usertk);
        },
        logout(){
            localStorage.removeItem('usprovdb');
            cookies.remove('pvckid');
            setUser(null);
            setToken('');
        },
        isLogged(){
            return !!user;
        }
    }
    
    return <AuthContext.Provider value={sesion}>
        {children}
    </AuthContext.Provider>
}
